export enum DecimalTypeEnum {
  'DECIMAL_1digit' = 1,
  'DECIMAL_2digit' = 2,
  'DECIMAL_3digit' = 3,
  'DECIMAL_4digit' = 4,
  'DECIMAL_5digit' = 5,
  'DECIMAL_0digit' = 16,
}